export enum Patterns {
  URL = 'https?://.+',
}
